import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["onChange", "ref"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Box, Flex, Text } from '@chakra-ui/react';
import { Controller } from 'react-hook-form';
import Checkbox from '../../Checkbox';
import FormError from '../FormError';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function FormCheckbox(_ref) {
  var control = _ref.control,
    formField = _ref.formField,
    errors = _ref.errors;
  return _jsx(Flex, _objectSpread(_objectSpread({
    direction: "column"
  }, _objectSpread(_objectSpread({}, defaultStyles), formField.styles)), {}, {
    "data-testid": formField.testid,
    children: _jsx(Controller, {
      name: formField.name,
      control: control,
      render: _ref2 => {
        var field = _ref2.field;
        var _onChange = field.onChange,
          _ = field.ref,
          extraPropsField = _objectWithoutProperties(field, _excluded);
        return _jsxs(Box, {
          "data-testid": formField.testid,
          "data-fieldname": formField.name,
          children: [_jsx(Checkbox, _objectSpread(_objectSpread(_objectSpread({}, formField.props), extraPropsField), {}, {
            onChange: o => {
              var _formField$onChange;
              (_formField$onChange = formField.onChange) === null || _formField$onChange === void 0 || _formField$onChange.call(formField, o.target.checked);
              _onChange(o.target.checked);
            },
            children: _jsx(Text, {
              as: "div",
              children: formField.label
            })
          })), _jsx(FormError, {
            errors: errors,
            name: formField.name
          })]
        });
      }
    })
  }));
}
var defaultStyles = {
  marginBottom: 'var(--chakra-space-md)'
};